export const CALENDAR_DAYS = "Calendar Days";
export const DAYS_FROM_FILING = "Days From Complaint Filing";
